export default __webpack_public_path__ + "static/media/pull-epull-floor.ddd2a09e.png";